export default function ToUppercase(value: string) { return value.toUpperCase(); }
